<template>
        <!-- Tools and Skills -->
    <section class="designer p-5">
        <div class="container">
            <div class="row m-5">
                <div class="col">
                    <h2 class="text-center text-white">Tools and Skills</h2>
                </div>
            </div>
            <div class="row d-flex justify-content-between">
                <div class="col-md col-sm-4 text-center">
                    <img src="assets/img/figma 1.png" class="figure-img img-fluid">
                </div>
                <div class="col-md col-sm-4 text-center">
                    <img src="assets/img/AdobeXD 1.png" class="figure-img img-fluid">
                </div>
                <div class="col-md col-sm-4 text-center">
                    <img src="assets/img/bootstrap.png" class="figure-img img-fluid">
                </div>
                <div class="col-md col-sm-4 text-center">
                    <img src="assets/img/html 1.png" class="figure-img img-fluid">
                </div>
                <div class="col-md col-sm-4 text-center">
                    <img src="assets/img/css3 1.png" class="figure-img img-fluid">
                </div>
                <div class="col-md col-sm-4 text-center">
                    <img src="assets/img/js.png" class="figure-img img-fluid">
                </div>
                <div class="col-md col-sm-4 text-center">
                    <img src="assets/img/Vue.png" class="figure-img img-fluid">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
// import carousel from 'vue-owl-carousel';

export default {
    name: 'Skills',
    // components: {
    //     carousel
    // }
}
</script>

<style>
    .designer {
        font-family: 'Rubik', sans-serif !important; 
        margin-top: 100px !important;
    }
</style>